<template>
    <div class="searchInputStyle">
        <img :src="isearch" alt="">
        <input type="text" placeholder="Pesquisar..." :value="valorDigitado" @input="onInput">
    </div>
</template>

<script>
import isearch from "@/assets/image/isearch.svg";
export default {
    data() {
        return {
            valorDigitado: "",
            isearch
        }
    },

    methods: {
        onInput(e) {
            this.$emit("valorDigitado", e.target.value)
        }
    }
}
</script>

<style scoped>
.searchInputStyle {
    padding: 5px;
    display: flex;

}

.searchInputStyle input {
    padding-left: 35px;
    outline: none;
    background: var(--colorFilterButton);
    border: none;
    border-radius: 7px;
    width: 100%;
    height: 2rem;
    margin-bottom: .5rem;
}

.searchInputStyle img{
    position: absolute;
    margin: 5px;
    width: 22px;
}
</style>